import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

/* Layout */
import Layout from '../views/layout/Layout'

/**
 * hidden: true                   if `hidden:true` will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu, whatever its child routes length
 *                                if not set alwaysShow, only more than one route under the children
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noredirect           if `redirect:noredirect` will no redirct in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    title: 'title'               the name show in submenu and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar,
  }
 **/
export const constantRouterMap = [{
		path: '/login',
		component: () => import('@/views/login/index'),
		hidden: true
	},
	{
		path: '/404',
		component: () => import('@/views/404'),
		hidden: true
	},
	{
		path: '',
		component: Layout,
		redirect: '/property'
	}
]

export const asyncRouterMap = [{
		path: '/property',
		component: Layout,
		redirect: '/property/list',
		name: 'property',
		meta: {
			title: '房源管理',
			icon: 'property'
		},
		alwaysShow: true,
		children: [{
				path: 'list',
				name: 'property:list',
				component: () => import('@/views/property/list'),
				meta: {
					title: '房源列表'
				}
			},
			// {
			// 	path: 'review',
			// 	name: 'property:review',
			// 	component: () => import('@/views/property/review'),
			// 	meta: {
			// 		title: '房源审核列表'
			// 	}
			// },
			{
				path: 'feedback',
				name: 'property:feedback',
				component: () => import('@/views/property/feedback'),
				meta: {
					title: '房源反馈'
				}
			}
		]
	},
	// {
	// 	path: '/statistics',
	// 	component: Layout,
	// 	redirect: '/statistics/list',
	// 	name: 'statistics',
	// 	meta: {
	// 		title: '房源发布统计',
	// 		icon: 'statistics'
	// 	},
	// 	alwaysShow: true,
	// 	children: [{
	// 		path: 'list',
	// 		name: 'statistics:list',
	// 		component: () => import('@/views/statistics/list'),
	// 		meta: {
	// 			title: '房源发布统计'
	// 		}
	// 	}]
	// },
	{
		path: '/repairManage',
		component: Layout,
		redirect: '/repairManage/list',
		name: 'repairManage',
		meta: {
			title: '维修管理',
			icon: 'repairManage'
		},
		alwaysShow: true,
		children: [{
			path: 'list',
			name: 'rentManage:list',
			component: () => import('@/views/repairManage/list'),
			meta: {
				title: '维修管理'
			}
		}]
	},
	{
		path: '/rentManage',
		component: Layout,
		redirect: '/rentManage/list',
		name: 'rentManage',
		meta: {
			title: '求租管理',
			icon: 'rentManage'
		},
		alwaysShow: true,
		children: [{
			path: 'list',
			name: 'rentManage:list',
			component: () => import('@/views/rentManage/list'),
			meta: {
				title: '求租管理'
			}
		}]
	},
	{
		path: '/userManage',
		component: Layout,
		redirect: '/userManage/list',
		name: 'userManage',
		meta: {
			title: '用户管理',
			icon: 'userManage'
		},
		alwaysShow: true,
		children: [{
			path: 'list',
			name: 'userManage:list',
			component: () => import('@/views/userManage/list'),
			meta: {
				title: '用户管理'
			}
		}]
	},
	{
		path: '/evaluate',
		component: Layout,
		redirect: '/evaluate/list',
		name: 'evaluate',
		meta: {
			title: '房源评价',
			icon: 'evaluate'
		},
		alwaysShow: true,
		children: [{
			path: 'list',
			name: 'evaluate:list',
			component: () => import('@/views/evaluate/list'),
			meta: {
				title: '房源评价'
			}
		}]
	},
	{
		path: '/contractManage',
		component: Layout,
		redirect: '/contractManage/list',
		name: 'contractManage',
		meta: {
			title: '合同管理',
			icon: 'contractManage'
		},
		alwaysShow: true,
		children: [{
			path: 'list',
			name: 'contractManage:list',
			component: () => import('@/views/contractManage/list'),
			meta: {
				title: '合同管理'
			}
		}]
	},
	{
		path: '/withdrawManage',
		component: Layout,
		redirect: '/withdrawManage/list',
		name: 'withdrawManage',
		meta: {
			title: '提现管理',
			icon: 'withdrawManage'
		},
		alwaysShow: true,
		children: [{
			path: 'list',
			name: 'withdrawManage:list',
			component: () => import('@/views/withdrawManage/list'),
			meta: {
				title: '提现管理'
			}
		}]
	},
	{
		path: '/memberManage',
		component: Layout,
		redirect: '/memberManage/index',
		name: 'memberManage',
		meta: {
			title: '会员管理',
			icon: 'memberManage'
		},
		alwaysShow: true,
		children: [{
				path: 'index',
				name: 'memberManage:index',
				component: () => import('@/views/memberManage/index'),
				meta: {
					title: '会员管理'
				}
			},
			{
				path: 'benefitList',
				name: 'memberManage:benefitList',
				component: () => import('@/views/memberManage/benefitList'),
				meta: {
					title: '权益列表'
				}
			}
		]
	},
	{
		path: '/benefitOrder',
		component: Layout,
		redirect: '/benefitOrder/list',
		name: 'benefitOrder',
		meta: {
			title: '权益订单',
			icon: 'benefitOrder'
		},
		alwaysShow: true,
		children: [{
			path: 'list',
			name: 'benefitOrder:list',
			component: () => import('@/views/benefitOrder/list'),
			meta: {
				title: '订单列表'
			}
		}]
	},
	{
		path: '/communityManage',
		component: Layout,
		redirect: '/communityManage/index',
		name: 'communityManage',
		meta: {
			title: '社区管理',
			icon: 'communityManage'
		},
		alwaysShow: true,
		children: [{
			path: 'index',
			name: 'communityManage:index',
			component: () => import('@/views/communityManage/index'),
			meta: {
				title: '社区管理'
			}
		}]
	},
	{
		path: '/sysFeedback',
		component: Layout,
		redirect: '/sysFeedback/list',
		name: 'sysFeedback',
		meta: {
			title: '系统反馈',
			icon: 'sysFeedback'
		},
		alwaysShow: true,
		children: [{
			path: 'list',
			name: 'sysFeedback:list',
			component: () => import('@/views/sysFeedback/list'),
			meta: {
				title: '系统反馈'
			}
		}]
	},
	{
		path: '/admin',
		component: Layout,
		redirect: '/admin/adimnList',
		name: 'admin',
		meta: {
			title: '系统管理',
			icon: 'system'
		},
		alwaysShow: true,
		children: [{
				path: 'taodouSet',
				name: 'admin:taodou:set',
				component: () => import('@/views/system/taodouSet'),
				meta: {
					title: '淘豆设置'
				}
			}, {
				path: 'carouselChart',
				name: 'admin:carousel:chart',
				component: () => import('@/views/system/carouselChart'),
				meta: {
					title: '轮播图'
				}
			},
			{
				path: 'classifyManage',
				name: 'admin:classify',
				component: () => import('@/views/system/classifyManage'),
				meta: {
					title: '分类管理'
				}
			},
			// {
			// 	path: 'equipmentList',
			// 	name: 'admin:equipment:list',
			// 	component: () => import('@/views/system/equipmentList'),
			// 	meta: {
			// 		title: '配套设备管理'
			// 	}
			// },
			// {
			// 	path: 'scheduleList',
			// 	name: 'admin:schedule:list',
			// 	component: () => import('@/views/schedule/list'),
			// 	meta: {
			// 		title: '定时任务列表'
			// 	}
			// },
			// {
			// 	path: 'scheduleLog',
			// 	name: 'admin:schedule:log',
			// 	component: () => import('@/views/schedule/log'),
			// 	meta: {
			// 		title: '定时任务日志'
			// 	}
			// },
			// {
			// 	path: 'scheduleUpdate',
			// 	name: 'admin:schedule:update',
			// 	component: () => import('@/views/schedule/updateSchedule'),
			// 	meta: {
			// 		title: '更新定时任务'
			// 	},
			// 	hidden: true
			// },
			{
				path: 'adimnList',
				name: 'admin:admin',
				component: () => import('@/views/adminUser/list'),
				meta: {
					title: '用户列表'
				}
			},
			{
				path: 'adminUpdate',
				name: 'admin:admin:update',
				component: () => import('@/views/adminUser/update'),
				meta: {
					title: '更新系统用户'
				},
				hidden: true
			},
			{
				path: 'deptList',
				name: 'admin:dept:list',
				component: () => import('@/views/adminUser/dept'),
				meta: {
					title: '部门管理'
				},
				hidden: true
			},
			{
				path: 'adminRole',
				name: 'admin:role',
				component: () => import('@/views/role/list'),
				meta: {
					title: '角色列表'
				}
			},
			{
				path: 'roleAdd',
				name: 'admin:role:add',
				component: () => import('@/views/role/update'),
				meta: {
					title: '更新角色'
				},
				hidden: true
			},
			{
				path: 'adminConfig',
				name: 'admin:config',
				component: () => import('@/views/config/list'),
				meta: {
					title: '配置列表'
				}
			},
			// {
			// 	path: 'ratioList',
			// 	name: 'user:ratio',
			// 	component: () => import('@/views/ratio/list'),
			// 	meta: {
			// 		title: '其他'
			// 	}
			// },
			{
				path: 'configUpdate',
				name: 'admin:config:add',
				component: () => import('@/views/config/update'),
				meta: {
					title: '更新'
				},
				hidden: true
			},
			{
				path: 'adminLog',
				name: 'admin:log',
				component: () => import('@/views/adminLog/list'),
				meta: {
					title: '系统日志'
				}
			},
			{
				path: 'adminLogDetail',
				name: 'admin:log:detail',
				component: () => import('@/views/adminLog/detail'),
				meta: {
					title: '日志详情'
				},
				hidden: true
			},
			{
				path: 'adminDict',
				name: 'admin:dict',
				component: () => import('@/views/dict/list'),
				meta: {
					title: '字典管理'
				}
			},
			{
				path: 'adminDictData',
				name: 'admin:dict:data',
				component: () => import('@/views/dict/data'),
				meta: {
					title: '字典数据'
				},
				hidden: true
			},
			{
				path: 'apkSetting',
				name: 'admin:apk:setting',
				component: () => import('@/views/system/apkSetting'),
				meta: {
					title: '安装包管理'
				}
			},
		]
	},
	{
		path: '*',
		redirect: '/404',
		hidden: true
	}
]

export default new Router({
	// mode: 'history', //后端支持可开
	scrollBehavior: () => ({
		y: 0
	}),
	routes: constantRouterMap
})


// WEBPACK FOOTER //
// ./src/router/index.js